/**
 * The app team will be introducing app-only skus. These will be available to buy only on the app
 *
 * @module views/components/EarlyAccessContent
 * @memberof -Common
 */
import './EarlyAccessContent.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Icon from '@ulta/core/components/Icon/Icon';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Markdown from '@ulta/core/components/Markdown/Markdown';
import { useDeviceInflection } from '@ulta/core/providers/InflectionProvider/InflectionProvider';
import { spreadProps } from '@ulta/core/utils/dom/dom';

import ActionGroups from '@ulta/modules/ActionGroups/ActionGroups';

import QrCode from '@ulta/components/QrCode/QrCode';

/**
 * Represents a EarlyAccessContent component
 *
 * @method
 * @param { EarlyAccessContentProps} props - React properties passed from composition
 * @returns EarlyAccessContent
 */
export const EarlyAccessContent = function( props ){
  const { icon, description, defaultAction, actionGroup, qrCodeLink } = props;
  const { breakpoint } = useDeviceInflection();

  return (
    <div className='EarlyAccessContent'>
      <div className='EarlyAccessContent__Content'>
        { icon && (
          <div className='EarlyAccessContent__Icon'>
            <Icon name={ icon }
              size='custom'
            />
          </div> ) }

        { description && (
          <Markdown bodyStyle='body-2'
            cmsMarkdownContent={ description }
            alignment='center'
          />
        ) }
      </div>
      { ( defaultAction && defaultAction?.label ) &&
        <div className='EarlyAccessContent__Action '>
          {
            <Link_Huge
              likeButtonSecondary={ true }
              url={ defaultAction.url }
              action={ defaultAction }
              fullWidth={ true }
            >
              { defaultAction.label }
            </Link_Huge>
          }
        </div>
      }

      { actionGroup &&
        <div className='EarlyAccessContent__Action'>
          {
            <ActionGroups
              { ...spreadProps( { ...actionGroup } ) }
            />
          }
        </div>
      }

      { qrCodeLink && (
        <div className='EarlyAccessContent__QrCode'>
          <QrCode url={ qrCodeLink.url }
            size={ breakpoint.CURRENT_BREAKPOINT === 'XL' ? 105 : 85 }
          />
        </div>
      ) }
    </div>
  );
};

/**
 * Property type definitions
 * @typedef EarlyAccessContentProps
 * @type {object}
 * @property {string} icon - shows the icon
 * @property {string} description - shows the description
 * @property {object} defaultAction - defaultAction for link
 * @property {object} actionGroup - actionGroup for ActionGroups
 * @property {object} qrCodeLink - shows qrCodeLink
 */
export const propTypes =  {
  icon: PropTypes.string,
  description: PropTypes.string,
  defaultAction: PropTypes.object,
  actionGroup: PropTypes.object,
  qrCodeLink: PropTypes.object
};

EarlyAccessContent.propTypes = propTypes;

export default EarlyAccessContent;
